module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Drone.48de3bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Drone.jpg
// module id = vmWW
// module chunks = 0